export default __webpack_public_path__ + "static/media/login_back.678eb87b.jpg";